import { render, staticRenderFns } from "./tab-order.vue?vue&type=template&id=4c54ce85&scoped=true"
import script from "./tab-order.vue?vue&type=script&lang=js"
export * from "./tab-order.vue?vue&type=script&lang=js"
import style0 from "./tab-order.vue?vue&type=style&index=0&id=4c54ce85&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54ce85",
  null
  
)

export default component.exports